import React from 'react';
import PropTypes from 'prop-types';
import { safeRest } from '@wds/utils';
import { CSSTransition } from 'react-transition-group';

import useStyles from './useStyles';

const Zoom = ({ children, timeout, ...rest }) => {
  const classes = useStyles({ timeout });
  return (
    <CSSTransition
      className={classes.wdsZoom}
      classNames={{ ...classes }}
      timeout={timeout}
      unmountOnExit
      {...safeRest(rest)}
    >
      {children}
    </CSSTransition>
  );
};

Zoom.propTypes = {
  children: PropTypes.node.isRequired,
  /**
   * Set timeout delay for transition
   */
  timeout: PropTypes.number,
};

Zoom.defaultProps = {
  timeout: 250,
};

export default Zoom;
